import React from "react";
import Icon from "react-icons-kit";
import { check } from "react-icons-kit/feather/check";

export const TickRenderer = (val, comp) => {
  return val === comp ? <Icon size={20} icon={check} /> : null;
};



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/TickRenderer.jsx